import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "services" }

import ServicesItem from './ServicesItem.vue'
import ServicesIcon from './ServicesIcon.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'Services',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ServicesItem, {
      span: 2,
      onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select', 'invisalign')))
    }, {
      default: _withCtx(() => [
        _createVNode(ServicesIcon, {
          alt: "Invisalign icon",
          icon: "invisalign"
        }),
        _createElementVNode("span", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('services.invisalign')), 1),
          _cache[13] || (_cache[13] = _createElementVNode("i", { class: "copyright" }, "®", -1))
        ])
      ]),
      _: 1
    }),
    _createVNode(ServicesItem, {
      onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select', 'myobrace')))
    }, {
      default: _withCtx(() => [
        _createVNode(ServicesIcon, {
          alt: "Myobrace icon",
          icon: "myobrace"
        }),
        _createElementVNode("span", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('services.myobrace')), 1),
          _cache[14] || (_cache[14] = _createElementVNode("i", { class: "copyright" }, "®", -1))
        ])
      ]),
      _: 1
    }),
    _createVNode(ServicesItem, {
      onSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('select', 'protetika')))
    }, {
      default: _withCtx(() => [
        _createVNode(ServicesIcon, {
          alt: "Prosthetics icon",
          icon: "prosthetics"
        }),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('services.protetikaBold')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('services.protetikaSuffix')), 1)
      ]),
      _: 1
    }),
    _createVNode(ServicesItem, {
      onSelect: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('select', 'injekcijska-tehnika')))
    }, {
      default: _withCtx(() => [
        _createVNode(ServicesIcon, {
          alt: "Composite bonding icon",
          icon: "injekcijska"
        }),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('services.injekcijskaTehnikaBold')), 1),
        _createTextVNode("  " + _toDisplayString(_ctx.$t('services.injekcijskaTehnikaSuffix')), 1)
      ]),
      _: 1
    }),
    _createVNode(ServicesItem, {
      onSelect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('select', 'beljenje')))
    }, {
      default: _withCtx(() => [
        _createVNode(ServicesIcon, {
          alt: "Whitening icon",
          icon: "whitening"
        }),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('services.beljenjeBold')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('services.beljenjeSuffix')), 1)
      ]),
      _: 1
    }),
    _createVNode(ServicesItem, {
      onSelect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('select', 'endodontsko')))
    }, {
      default: _withCtx(() => [
        _createVNode(ServicesIcon, {
          alt: "Endodontics icon",
          icon: "endodontics",
          translate: "0, -5px"
        }),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('services.endodontskoBold')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('services.endodontskiSuffix')), 1)
      ]),
      _: 1
    }),
    _createVNode(ServicesItem, {
      onSelect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('select', 'karies')))
    }, {
      default: _withCtx(() => [
        _createVNode(ServicesIcon, {
          alt: "Tooth decay icon",
          icon: "tooth-decay",
          translate: "0, -5px"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('services.kariesPrefix')) + " ", 1),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('services.kariesa')), 1)
      ]),
      _: 1
    }),
    _createVNode(ServicesItem, {
      onSelect: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('select', 'parodontologija')))
    }, {
      default: _withCtx(() => [
        _createVNode(ServicesIcon, {
          alt: "Periodontitis icon",
          icon: "periodontitis",
          translate: "0, 5px"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('services.parodontologiaPrefix')) + " ", 1),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('services.parodontologijaBold')), 1)
      ]),
      _: 1
    }),
    _createVNode(ServicesItem, {
      onSelect: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('select', 'lasersko')))
    }, {
      default: _withCtx(() => [
        _createVNode(ServicesIcon, {
          alt: "Laser icon",
          icon: "laser"
        }),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('services.laskerskoBold')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('services.lasterskoSuffix')), 1)
      ]),
      _: 1
    }),
    _createVNode(ServicesItem, {
      span: 2,
      onSelect: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('select', 'frenulotomija')))
    }, {
      default: _withCtx(() => [
        _createVNode(ServicesIcon, {
          alt: "Frenulotomy icon",
          icon: "frenulotomy"
        }),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('services.frenulotomijaBold')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('services.frenulotomijaSuffix')), 1)
      ]),
      _: 1
    }),
    _createVNode(ServicesItem, {
      onSelect: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('select', 'ortopan')))
    }, {
      default: _withCtx(() => [
        _createVNode(ServicesIcon, {
          alt: "Dental x-ray icon",
          icon: "dental-x-ray",
          translate: "0, 5px"
        }),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('services.ortopanBold')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('services.ortopanSuffix')), 1)
      ]),
      _: 1
    }),
    _createVNode(ServicesItem, {
      onSelect: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('select', 'pregledi')))
    }, {
      default: _withCtx(() => [
        _createVNode(ServicesIcon, {
          alt: "Dental chair icon",
          icon: "dental-chair"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('services.preglediPrefix')) + " ", 1),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('services.preglediBold')), 1)
      ]),
      _: 1
    }),
    _createVNode(ServicesItem, {
      onSelect: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('select', 'otrosko')))
    }, {
      default: _withCtx(() => [
        _createVNode(ServicesIcon, {
          alt: "Child icon",
          icon: "child"
        }),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('services.otroskoBold')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('services.otroskoSuffix')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})